module.exports = __webpack_public_path__ + "img/illinoisAdventure@3x.6861e476.png";